jQuery(function ($) {
  const temaEnv = window?.drupalSettings?.tema;
  const baseUrl = temaEnv?.sna_accesspass_api;
  const apiToken = temaEnv?.sna_accesspass_api_token;

  $("#register-btn").on("click", function () {
    const logout_token = sessionStorage.getItem("login-token");
    const event_id = $("#event-detail-id").data("id");
    const hasInventory = $("#event-detail-id").data("hasinventory");

    // console.log("xxx has inventory", hasInventory);
    var data = {
      event_id: event_id,
    };

    // console.log(data);
    $.ajax({
      url: baseUrl + "/event/register",
      method: "POST",
      data: JSON.stringify(data),
      dataType: "json",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + logout_token, // Add a space after "Bearer"
      },
      success: function (response) {
        //successfully registered for an event
        addToRegisteredEvents(event_id);
        $("#register-btn").hide();
        $("#event-registered").css("display", "flex");

        if (hasInventory) {
          // console.log("xxx has inventory le");
          const modalInventory = document.querySelectorAll(".modal-inventory");

          modalInventory.forEach((modal) => {
            modal.classList.add("show-modal-news");
            // modal.classList.remove("invisible");
            // modal.classList.remove("opacity-0");
          });
        }
      },
      error: function (error) {
        console.log(error);
      },
    });
  });

  function addToRegisteredEvents(id) {
    // Get the existing registeredEvent data from sessionStorage
    var registeredEvents =
      JSON.parse(sessionStorage.getItem("registeredEvent")) || [];

    // Check if the ID already exists in the array
    if (registeredEvents.indexOf(id) === -1) {
      // Add the ID to the array
      registeredEvents.push(id);
      // Store the updated array back in sessionStorage
      sessionStorage.setItem(
        "registeredEvent",
        JSON.stringify(registeredEvents)
      );
      // console.log('ID ' + id + ' added to registeredEvent.');
    } else {
      // console.log('ID ' + id + ' already exists in registeredEvent.');
    }
  }
});
